import { ICheckpointEntry } from '../../../../contentful/types/ICheckpointEntry';
import { ISecurityCheckpoint } from '../models/ISecurityCheckpoint';

export function applyContentfulOverrides(
	apiCheckpoints: ISecurityCheckpoint[],
	contentfulCheckpoints?: ICheckpointEntry[],
): ISecurityCheckpoint[] {
	if (!contentfulCheckpoints?.length) {
		return apiCheckpoints;
	}

	return apiCheckpoints.map((checkpoint) => {
		const contentfulMatch = contentfulCheckpoints.find(
			(entry) => entry.fields.checkpointCode === checkpoint.id,
		);

		if (contentfulMatch?.fields.override) {
			return {
				...checkpoint,
				override: true,
				remark: contentfulMatch.fields.remark ?? null,
			};
		}

		return checkpoint;
	});
}
